import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, ErrorHandler, Optional, SkipSelf } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Login
import { LoginComponent } from '../modules/login/login.component';

// Mirage Component
import { AppLayoutModule } from '../layout/app.layout.module';

// Interceptor
import { TokenInterceptor } from '../interceptors/token.interceptor';
import { CustomErrorHandlerService } from '../services/custom-error-handler.service';

// Localisation
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr);

import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../modules/shared.module';

@NgModule({
  declarations: [LoginComponent],
  imports: [BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }), CommonModule, HttpClientModule, FormsModule, BrowserAnimationsModule, SharedModule, AppRoutingModule, AppLayoutModule],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'fr-FR',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandlerService,
    },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule a déja été chargé. Vous ne devez importer les modules Core que dans AppModule');
    }
  }
}
